import { useSuspenseQuery } from "@tanstack/react-query";
import { fetchMyAccountInfo } from "PFCore/services/accounts/account";
import { MyAccountInfo } from "PFTypes";
import { SuspenseQueryOptions } from "PFTypes/request_options";

import { accountKeys } from "./query_keys";

export const useMyAccountInfo = (options?: SuspenseQueryOptions<MyAccountInfo>) =>
  useSuspenseQuery<MyAccountInfo>({
    queryKey: accountKeys.myAccountInfo(),
    queryFn: () => fetchMyAccountInfo(),
    retry: false,
    ...options
  });
